<template>
  <div class="col-md-2 col-sm-6 col-xs-6 mobile">
    <span v-if="!label">Sub Grupo</span>
    <q-select
      dense
      outlined
      v-model="subGrupo"
      use-input
      @input-value="setModel"
      input-debounce="0"
      :options="listaGrupos"
      hide-selected
      fill-input
      option-label="nome"
      option-value="uuid"
      :label="label"
      :rounded="rounded"
      @filter="filterFn"
      :hint="hint"
    >
    </q-select>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  name: "SelectComponentSubGrupos",
  emits: ["emitirSubGrupo"],
  props: [
    "uuid",
    "model",
    "categoriaUuid",
    "resetar",
    "hint",
    "label",
    "rounded",
  ],

  setup(props, { emit }) {
    const store = useStore();
    const time = ref();
    const listaGrupos = ref([]);
    const lista = ref([]);
    const subGrupo = ref(props.model);

    watch(
      () => subGrupo.value,
      () => {
        if (subGrupo.value == undefined || subGrupo.value == "") {
          return;
        }
        emit("emitirSubGrupo", subGrupo.value);
      }
    );

    watch(
      () => props.uuid,
      () => {
        consultarGrupo(props.uuid);
      }
    );

    let listarGrupos = async (val) => {
      if (val === "") {
        listaGrupos.value = [];
        subGrupo.value = "";
        return;
      }
      try {
        let resposta = await store.dispatch("fer/listarGrupos", {
          rowsPerPage: 100000,
          filtro: val || "",
          categoria_uuid: props.categoriaUuid,
        });

        listaGrupos.value = resposta.resposta.result.data;
        subGrupo.value = resposta.resposta.result.data[0];
      } catch (error) {
        console.log(error);
      }
    };

    let consultarGrupo = async (id) => {
      let resposta = await store.dispatch("fer/consultarGrupo", {
        uuid: id,
      });
      subGrupo.value = resposta.grupo;
    };

    watch(
      () => props.model,
      () => {
        subGrupo.value = props.model;
      }
    );

    watch(
      () => props.categoriaUuid,
      () => {
        if (
          subGrupo.value?.categoria_uuid != props.categoriaUuid ||
          props.categoriaUuid == undefined ||
          props.categoriaUuid === ""
        ) {
          subGrupo.value = "";
          emit("emitirSubGrupo", subGrupo.value);
        }
      }
    );

    watch(
      () => props.resetar,
      () => {
        subGrupo.value = "";
      }
    );

    return {
      listaGrupos,
      subGrupo,
      lista,
      consultarGrupo,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarGrupos(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      setModel(val) {
        if (val === "") {
          subGrupo.value = val;
        }
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 1343px) {
  .mobile {
    height: auto;
  }
}
</style>
